import React, { Component } from 'react';
import ReportsLayout from '../../templates/reports';
import Financial from '../../elements/reports/financial';
import Loading from './../../elements/loading';

class ReportsFinancial extends Component{
	render (){
		const { reports, revision, directories, status } = this.props;
		const { financial } = reports;
		return (
			(directories.isFetching || status.isFetching || revision.isFetching || financial.isFetching) ?
				<Loading/>:<Financial {...this.props}/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		this.props.reset('reports');
		this.props.fetchActorsList();
		this.props.actorsGroups();
		this.props.fetchConagoList();
		this.props.statusMotivesList();
		this.props.reportsFinancial(modality, state, municipality);

	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;

		if(newprops.match.params !== this.props.match.params) {
			this.props.reportsFinancial(modality, state, municipality);
		}
	}
}

export default ReportsLayout(ReportsFinancial, {subnav: 1});


// WEBPACK FOOTER //
// ./src/layouts/reports/financial.jsx